import en from '../../i18n/en';
import de from '../../i18n/de';
import ru from '../../i18n/ru';

// initial state
const state = {
    text: null
};

// mutations
const mutations = {
    text(state, text) {
        state.text = text;
    }
};

// getters
export const getters = {
    translate: state => code => {
        if (state.text) {
            const translation = state.text[code];
            return translation ? translation : code;
        }
        return null;
    }
};

// actions
const actions = {
    init(store, culture) {
        switch (culture) {
        case 'en':
            store.commit('text', en);
            break;
        case 'de':
            store.commit('text', de);
            break;
        case 'ru':
            store.commit('text', ru);
            break;

        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/translation.js